export default function Footer() {
  return (
    <footer id="footer" className="w-full bg-foreground-900 text-background-50">
      <div className="w-full px-4 md:px-6 py-12 md:py-16 max-w-[1280px] mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-movie-2-fill text-white text-lg"></i>
              </span>
              <span className="font-heading text-lg font-bold text-background-50">
                被窝影院
              </span>
            </div>
            <p className="text-sm text-foreground-300 leading-relaxed mb-4">
              被窝影院电影大全免费看，提供最新电影免费看和高分电影在线服务。电影大全无广告，院线电影免费经典电影全集，不缓冲流畅在线观看，满足各类影迷需求。
            </p>
            <div className="flex items-center gap-3">
              <a href="#hero" onClick={(e) => { e.preventDefault(); document.querySelector('#hero')?.scrollIntoView({ behavior: 'smooth' }); }} className="w-8 h-8 flex items-center justify-center rounded-lg bg-foreground-800 text-foreground-300 hover:text-background-50 hover:bg-primary-500 transition-colors duration-200 cursor-pointer">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#hero" onClick={(e) => { e.preventDefault(); document.querySelector('#hero')?.scrollIntoView({ behavior: 'smooth' }); }} className="w-8 h-8 flex items-center justify-center rounded-lg bg-foreground-800 text-foreground-300 hover:text-background-50 hover:bg-primary-500 transition-colors duration-200 cursor-pointer">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#hero" onClick={(e) => { e.preventDefault(); document.querySelector('#hero')?.scrollIntoView({ behavior: 'smooth' }); }} className="w-8 h-8 flex items-center justify-center rounded-lg bg-foreground-800 text-foreground-300 hover:text-background-50 hover:bg-primary-500 transition-colors duration-200 cursor-pointer">
                <i className="ri-bilibili-line text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="font-heading text-base font-bold text-background-50 mb-4">快速导航</h3>
            <ul className="space-y-2.5">
              {[
                { label: '首页', href: '#hero' },
                { label: '热门分类', href: '#cards' },
                { label: '热播排行', href: '#ranking' },
                { label: '最新动态', href: '#updates' },
                { label: '影视解说', href: '#media' },
                { label: '常见问题', href: '#faq' },
              ].map((item) => (
                <li key={item.href}>
                  <a
                    href={item.href}
                    onClick={(e) => {
                      e.preventDefault();
                      document.querySelector(item.href)?.scrollIntoView({ behavior: 'smooth' });
                    }}
                    className="text-sm text-foreground-400 hover:text-background-50 transition-colors duration-200 cursor-pointer"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-base font-bold text-background-50 mb-4">电影分类</h3>
            <ul className="space-y-2.5">
              {['动作片', '喜剧片', '科幻片', '爱情片', '恐怖片', '动画片', '纪录片', '战争片'].map((cat) => (
                <li key={cat}>
                  <a
                    href="#cards"
                    onClick={(e) => {
                      e.preventDefault();
                      document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
                    }}
                    className="text-sm text-foreground-400 hover:text-background-50 transition-colors duration-200 cursor-pointer"
                  >
                    {cat}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-base font-bold text-background-50 mb-4">合作伙伴</h3>
            <ul className="space-y-2.5">
              <li className="text-sm text-foreground-400">更多合作伙伴即将加入</li>
            </ul>

            <div className="mt-6">
              <h3 className="font-heading text-base font-bold text-background-50 mb-3">联系方式</h3>
              <div className="space-y-2 text-sm text-foreground-400">
                <p>邮箱：contact@beiwomovie.com</p>
                <p>微信：beiwo_movie</p>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-10 md:mt-12 pt-6 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; 2024-2026 被窝影院 版权所有 | 电影大全免费看，最新电影免费看，高分电影在线
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-500">
            <span>隐私政策</span>
            <span>服务条款</span>
            <span>版权声明</span>
          </div>
        </div>
      </div>
    </footer>
  );
}